import React from 'react';
import Button from '../../components/common/Button';
import '../../styles/signup-page.css';

const SignupSuccessPage: React.FC = () => {
  return (
    <div className="signup-page">
      {/* Hero */}
      <section className="signup-hero">
        <div className="container">
          <div className="signup-hero__content fade-in-up">
            <div
              style={{
                width: '80px',
                height: '80px',
                borderRadius: '50%',
                background: 'rgba(140, 237, 63, 0.12)',
                border: '2px solid rgba(140, 237, 63, 0.3)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 2rem',
                fontSize: '2.5rem',
                color: '#8ced3f',
              }}
            >
              {'\u2713'}
            </div>
            <h1 className="signup-hero__headline">
              Welcome to Inferium&nbsp;Reports!
            </h1>
            <p className="signup-hero__sub">
              Your account has been created. Check your email for login
              credentials.
            </p>
            <div
              style={{
                display: 'flex',
                gap: '0.75rem',
                justifyContent: 'center',
                flexWrap: 'wrap',
                marginTop: '2rem',
              }}
              className="fade-in-up-delay"
            >
              <Button
                variant="primary"
                size="lg"
                href="https://login.inferiumreports.com"
                target="_blank"
              >
                Go to Login
              </Button>
              <Button variant="outline" size="lg" href="/">
                Back to Home
              </Button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SignupSuccessPage;
